import { render, staticRenderFns } from "./ModalUploadDocument.vue?vue&type=template&id=04e2ca00&"
import script from "./ModalUploadDocument.vue?vue&type=script&lang=js&"
export * from "./ModalUploadDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports